<template>
  <v-row no-gutters>
    <v-col cols="12">
      <Select 
      v-model="selectedSection['type-ticket']"
      return-object
      label="Ingresso"
      :item-text="formatedItemTicket"
      :items="tickets.produtos"
      :showBorder="true"
      /> 
    </v-col>

    <v-col cols="12">
      <div class="_subtitleFormFont pt-6 pb-3">Texto:</div>
    </v-col>
    <v-col cols="12">
      <Texts textType="text" :sectionType="selectedSection.type" :selectedSection="selectedSection"/>
    </v-col>

    <v-col cols="12">
      <div class="_subtitleFormFont py-6">Formulário:</div>
    </v-col>
    <v-col cols="6" class="_pr-">
      <ColorPickerV2 title="Cor do fundo" :colorSelected="selectedSection" type="layer-color" /> 
    </v-col>
    <v-col cols="6" class="_pl-">
      <ColorPickerV2 title="Cor do texto" :colorSelected="selectedSection" type="text-color" /> 
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'
import Select from '../../../../_v2/ui/Select.vue'
import Texts from '../Texts.vue'

export default {
  name: 'Layout3',
  components: {ColorPickerV2, Select, Texts},
  props: {
    selectedSection: {type: Object, required: true}
  },
  computed: {
    ...mapGetters(["tickets"]),
  },  

  data: () => ({}),

  methods: {
    formatedItemTicket: (item) => item.nome + " - " + item.nome_tipo,
  }      
}
</script>

<style scoped>
</style>